<label class="container">
	<ng-content></ng-content>
	<input type="radio" [name]="name" [checked]="checked" (input)="onChange()" [id]="id" [ngClass]="[stackedClass]" #radioButtonContainer /> <span class="checkmark"></span>
</label>
